const guiColors = {
    'looks-secondary': 'hsla(215, 100%, 65%, 1)',
    'looks-tertiary': 'hsla(215, 100%, 55%, 1)',
    'looks-transparent': 'hsla(215, 100%, 65%, 0.35)',
    'looks-light-transparent': 'hsla(215, 100%, 65%, 0.15)',
    'looks-secondary-dark': 'hsla(215, 60%, 50%, 1)'
};

const blockColors = {};

export {
    guiColors,
    blockColors
};
